import { EssayCardTimeline, EssayCardTimelineDescription, EssayCardTimelinePosition, EssayCardTimelineScore, EssayCardTimelineScoreValue, EssayCardTimelineWrapper, EssayPageTimelineHeader, EssayPageTimelineTitle } from '@/components/custom/essay';
import { statusBadgeText } from './utils/BadgeEssay';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { useSession } from '@/hooks/useSession';
import { Badge } from '@/components/ui/badge';

export function EssayTimeline({ submissions, activeSubmission, setActiveSubmission, essayId }) {
  const navigate = useNavigate();
  const { session } = useSession();

  const validSubmissions = submissions?.filter(submission => submission.status !== 'minimum_length_not_satisfied');

  const checkScore = score => {
    if (score <= 333) {
      return 'text-danger';
    } else if (score > 333 && score <= 666) {
      return 'text-warning';
    } else if (score > 666) {
      return 'text-success';
    }
  };

  return (
    <>
      <EssayPageTimelineHeader>
        <EssayPageTimelineTitle>Envios</EssayPageTimelineTitle>
        {/* Aguardar definição da regra de quantidade de envios */}
        <span>{validSubmissions?.length}/2</span>
      </EssayPageTimelineHeader>

      <EssayCardTimelineWrapper>
        {validSubmissions?.map(item => (
          <EssayCardTimeline
            key={item?.id}
            isActive={activeSubmission === item?.id}
            onClick={() => {
              setActiveSubmission(item?.id);
              const link = session.user.profileNames.includes('Aluno') ? `/redacao/consulta/${essayId}/${item.id}` : `/redacao/correcao/${item.id}/${essayId}`;
              navigate(link);
            }}
          >
            <EssayCardTimelinePosition>{item?.['submission_order']}º</EssayCardTimelinePosition>
            <EssayCardTimelineDescription>
              <span>
                <strong>{item?.['submission_order']}º envio</strong>
              </span>
              <Badge
                variant="bright"
                size="xs"
                style={{ cursor: 'inherit' }}
              >
                {statusBadgeText[item?.status]}
              </Badge>
              <span>em {moment(item?.['submission_date']).format('DD/MM/YYYY')}</span>
            </EssayCardTimelineDescription>
            <EssayCardTimelineScore>
              <span>
                <EssayCardTimelineScoreValue className={checkScore(item.grade)}>{item.status === 'annulled' ? 'Anulada' : item?.grade}</EssayCardTimelineScoreValue>pontos
              </span>
            </EssayCardTimelineScore>
          </EssayCardTimeline>
        ))}
      </EssayCardTimelineWrapper>
    </>
  );
}
